<div *ngIf="env.envName === 'prod'">
  <link href="https://portrlivecdnstorage.blob.core.windows.net/assets/booking-pod-live.css?v=106&sp=r&st=2023-07-31T13:28:56Z&se=2028-01-08T22:28:56Z&spr=https&sv=2022-11-02&sr=c&sig=Kd1nL6EpQREvU2OVv8Znrpx0iNVvzJNgGsI%2Big%2Bixo0%3D" rel="stylesheet"
    type="text/css">
  <link href="https://portrlivecdnstorage.blob.core.windows.net/assets/portr-crm-popups-live.css?sp=r&st=2023-07-31T13:28:56Z&se=2028-01-08T22:28:56Z&spr=https&sv=2022-11-02&sr=c&sig=Kd1nL6EpQREvU2OVv8Znrpx0iNVvzJNgGsI%2Big%2Bixo0%3D" rel="stylesheet"
    type="text/css">
</div>
<div *ngIf="env.envName === 'uat'">
  <link href="https://portrlivecdnstorage.blob.core.windows.net/assets/booking-pod-uat.css?v=84&sp=r&st=2023-07-31T13:28:56Z&se=2028-01-08T22:28:56Z&spr=https&sv=2022-11-02&sr=c&sig=Kd1nL6EpQREvU2OVv8Znrpx0iNVvzJNgGsI%2Big%2Bixo0%3D" rel="stylesheet"
    type="text/css">
  <link href="https://portrlivecdnstorage.blob.core.windows.net/assets/portr-crm-popups-uat.css?sp=r&st=2023-07-31T13:28:56Z&se=2028-01-08T22:28:56Z&spr=https&sv=2022-11-02&sr=c&sig=Kd1nL6EpQREvU2OVv8Znrpx0iNVvzJNgGsI%2Big%2Bixo0%3D" rel="stylesheet"
    type="text/css">
</div>
<div *ngIf="env.envName === 'dev'">
  <link href="https://portrdevcdnstorage.blob.core.windows.net/assets/portr-booking-pod.css?sp=r&st=2023-07-26T14:30:30Z&se=2028-07-27T22:30:30Z&spr=https&sv=2022-11-02&sr=c&sig=lrXCJHXNa5alfjfV2ZFjU4KX1IcENLJsQGKmthZ8KP4%3D" rel="stylesheet" type="text/css">
  <link href="https://portrdevcdnstorage.blob.core.windows.net/assets/portr-crm-popups.css?sp=r&st=2023-07-26T14:30:30Z&se=2028-07-27T22:30:30Z&spr=https&sv=2022-11-02&sr=c&sig=lrXCJHXNa5alfjfV2ZFjU4KX1IcENLJsQGKmthZ8KP4%3D" rel="stylesheet"
    type="text/css">
</div>

<app-header componentRender="BeforeLogin"></app-header>

<div class='app-container'>
  <div class="content-container" >
    <!-- used to output each partial, e.g. account, booking, details, etc... -->
    <router-outlet></router-outlet>
    <app-notifications></app-notifications>
  </div>
  <app-overview-container></app-overview-container>
</div>

<app-login-overlay-section *ngIf="isUIVersionSet && showLoginOverlay" [sessionID]="sessionID" [userEmail]="sessionEmail"
  [userName]="userName" [userHasPassword]="userHasPassword" [userHasPhoneNumber]="userHasPhoneNumber"
  (closeOverlay)="closeOverlay($event)">
</app-login-overlay-section>

<app-translation-loader></app-translation-loader>

<div *ngIf="isMotoPayment" [ngClass]="{'isPaymentScreen': isPaymentScreen}" class='motoPayment'>
  <p>MOTO Payment</p>
</div>
<div id='portr-crm-popups' [attr.data-copy]='crmPopupContent'></div>

<div class="slot-version">
  <p class="prevent-select">Variant: <span class='uppercase-text'>{{ slotNumber }}</span>&nbsp;v{{ slotVersion }}</p>
</div>
<div class="hidden">
  <p>Version: {{ appVersion }}</p>
</div>
<div class="hidden">
  <p>Env: {{ env.abEnv }}</p>
</div>
